export const RGBA = {
  applyStep: (value, step, min, max) =>
    Math.max(min, Math.min(value + step, max)),
  normalize: (comps) => {
    if (comps.length < 4) {
      comps[3] = 1;
    }
    return comps;
  },
  build: (comps) => `rgba(${RGBA.normalize(comps).join(", ")})`,
  read: (rgba) =>
    RGBA.normalize(
      rgba
        .slice(rgba.indexOf("(") + 1, rgba.indexOf(")"))
        .split(",")
        .map((v) => v.trim())
        .map((v) => Number(v))
    ),
  opacityStep: (rgba, step) => {
    const comps = RGBA.read(rgba);
    comps[3] = RGBA.applyStep(comps[3], step, 0.0, 1.0);
    return RGBA.build(comps);
  },
  brightStep: (rgba, step) => {
    const comps = RGBA.read(rgba);
    comps[0] = RGBA.applyStep(comps[0], step, 0, 255);
    comps[1] = RGBA.applyStep(comps[1], step, 0, 255);
    comps[2] = RGBA.applyStep(comps[2], step, 0, 255);
    return RGBA.build(comps);
  },
};
